import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=0bc2050e&scoped=true"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"
import style0 from "./Parents.vue?vue&type=style&index=0&id=0bc2050e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2050e",
  null
  
)

export default component.exports